import { useMsal } from '@azure/msal-react';
import { InternalAxiosRequestConfig } from 'axios';

import { ReactNode, useEffect } from 'react';

import { AXIOS_INSTANCE } from '../../../orvalCustomAxiosInstance.ts';
import { loginRequest } from '../../authConfig.ts';
import getAccessToken from './GetAccessToken.tsx';

interface InterceptorProps {
    children: ReactNode;
}

const AxiosInterceptor = ({ children }: InterceptorProps) => {
    const { instance: msalInstance } = useMsal();

    useEffect(() => {
        const loginRedirectInterceptor = async (
            config: InternalAxiosRequestConfig<unknown>
        ) => {
            const accessToken = await getAccessToken(msalInstance);

            if (accessToken) {
                config.headers.set('Authorization', `Bearer ${accessToken}`);
            } else {
                msalInstance
                    .loginRedirect(loginRequest)
                    .catch(error => console.log(error));
            }

            return config;
        };

        const interceptor = AXIOS_INSTANCE.interceptors.request.use(
            loginRedirectInterceptor
        );

        return () => AXIOS_INSTANCE.interceptors.request.eject(interceptor);
    }, [msalInstance]);

    return children;
};

export default AxiosInterceptor;
